import { LANGUAGE_IDS, LOCALES } from './locales'

export const FLAGS = {
  [LANGUAGE_IDS[LOCALES.ENGLISH]]: 'EN',
  [LANGUAGE_IDS[LOCALES.SPANISH]]: 'ES',
  [LANGUAGE_IDS[LOCALES.PORTUGUESE_BR]]: 'PT',
}
